import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgInfoDesk = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3 3.75C3 4.54565 3.31607 5.30871 3.87868 5.87132C4.44129 6.43393 5.20435 6.75 6 6.75C6.79565 6.75 7.55871 6.43393 8.12132 5.87132C8.68393 5.30871 9 4.54565 9 3.75C9 2.95435 8.68393 2.19129 8.12132 1.62868C7.55871 1.06607 6.79565 0.75 6 0.75C5.20435 0.75 4.44129 1.06607 3.87868 1.62868C3.31607 2.19129 3 2.95435 3 3.75V3.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 13.5C11.25 12.1076 10.6969 10.7723 9.71231 9.78769C8.72774 8.80312 7.39239 8.25 6 8.25C4.60761 8.25 3.27226 8.80312 2.28769 9.78769C1.30312 10.7723 0.75 12.1076 0.75 13.5V15.75H3L3.75 23.25H8.25L9 15.75H11.25V13.5Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.125 3.375C16.125 4.07119 16.4016 4.73887 16.8938 5.23116C17.3861 5.72344 18.0538 6 18.75 6C19.4462 6 20.1139 5.72344 20.6062 5.23116C21.0984 4.73887 21.375 4.07119 21.375 3.375C21.375 2.67881 21.0984 2.01113 20.6062 1.51884C20.1139 1.02656 19.4462 0.75 18.75 0.75C18.0538 0.75 17.3861 1.02656 16.8938 1.51884C16.4016 2.01113 16.125 2.67881 16.125 3.375V3.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 11.25C14.25 10.0565 14.7241 8.91193 15.568 8.06802C16.4119 7.22411 17.5565 6.75 18.75 6.75C19.9435 6.75 21.0881 7.22411 21.932 8.06802C22.7759 8.91193 23.25 10.0565 23.25 11.25H14.25Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.738 11.25H23.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgInfoDesk.displayName = 'SvgInfoDesk';
export default SvgInfoDesk;
